import { render, staticRenderFns } from "./remove-unit-from-scan.vue?vue&type=template&id=32bb867f&"
import script from "./js/remove-unit-from-scan.js?vue&type=script&lang=js&"
export * from "./js/remove-unit-from-scan.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports